import { File } from "@shared-database/models/file";
import { sharedSchema } from "@shared-database/pgSchema";
import { leoNotNullForeignID, timestampColumns } from "@shared-database/utils";
import type { InferInsertModel, InferSelectModel } from "drizzle-orm";
import { text, index } from "drizzle-orm/pg-core";
import { createInsertSchema, createSelectSchema } from "drizzle-zod";

// NB! We have move the checksum to a separate table in the database to avoid accidental leaking of the checksum
export const FileChecksum = sharedSchema.table(
  "FileChecksum",
  {
    // Mixins
    ...timestampColumns,

    // Properties

    checksum: text("checksum").notNull(),
    id: leoNotNullForeignID("id")
      .references(() => File.id, {
        onDelete: "cascade",
      })
      .primaryKey(),
  },
  (table) => [
    index("FileChecksum_idIdx").on(table.id),
    index("FileChecksum_checksumIdx").on(table.checksum),
  ],
);

// Types & Schemas
export const FileChecksumInsertSchema = createInsertSchema(FileChecksum);
export const FileChecksumSelectSchema = createSelectSchema(FileChecksum);
export type FileChecksumType = InferSelectModel<typeof FileChecksum>;
export type FileChecksumInsertType = InferInsertModel<typeof FileChecksum>;
